{
 "_": "v243 BOSS-ONLY cards: they exist only as campaign bosses (never in packs, the set count, the binder or AI drafts). main.js appends them to the deck like the forged defs; scripts/campaign-core.mjs loads them for the sim. Art + clip are served by the droplet's art/clip routes from their v2 caches (uploaded by hand: data/nomadmon-art/v2/<id>.webp + thumb/, data/nomadmon-clips/v2/<id>.mp4).",
 "cards": [
  {
   "serial": "S1-BOSS-15",
   "set": "CAMPAIGN · THE EYE",
   "id": "eye-of-the-nomad",
   "name": "EYE OF THE NOMAD",
   "cardKind": "character",
   "person": "Damon",
   "type": "MYSTIC",
   "rarity": "mythic",
   "hp": 130,
   "spd": 6,
   "swapCost": 2,
   "moves": [
    { "name": "The Long Stare", "dmg": 38, "desc": "It has watched every road you took to get here. It is not impressed." },
    { "name": "All Fifteen Worlds", "dmg": 76, "effect": "The Eye opens fully: every realm it swallowed looks back at you at once.", "chargeRounds": 3, "ultimate": true }
   ],
   "keywords": ["GUARD", "PIERCE"],
   "flavor": "Every path rises to it. Every card was dealt beneath it.",
   "record": "0–0",
   "dex": "Damon, final form: the watching eye at the summit of the Nomad road.",
   "data": ["REALMS WATCHED: 15", "BLINKS: 0", "SIGNATURE: The Long Stare"],
   "focalX": 0.5,
   "variant": "living",
   "art": "/api/nomadmon/art/eye-of-the-nomad.webp",
   "clip": "/api/nomadmon/clip/eye-of-the-nomad.mp4",
   "bossOnly": true,
   "frame": "thin"
  }
 ]
}
